import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m9.484 5.434 1.094 2.625c.192.437.082.957-.3 1.257l-1.34 1.121a9.2 9.2 0 0 0 4.374 4.376l1.122-1.34c.3-.383.82-.493 1.257-.301l2.625 1.094c.52.191.766.765.63 1.285l-.657 2.406a1.08 1.08 0 0 1-1.039.793A12.23 12.23 0 0 1 5 6.5c0-.492.328-.902.793-1.04l2.406-.655c.52-.137 1.094.11 1.285.629"
    }, null, -1)
  ]))]))
}
export default { render: render }